import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { type Filters } from '../DateAndTime.helpers';
import DayFilters from '../DayFilters';

export default function FilterDialog({
	openFilterDialog,
	setOpenFilterDialog,
	setFilters,
	filters,
	setThreeDaySwitch,
	threeDaySwitch,
	setTimeOfDay,
	setWeekDays,
	weekDays,
	timeOfDay,
}: Readonly<{
	openFilterDialog: boolean;
	setOpenFilterDialog: (openFilterDialog: boolean) => void;
	setFilters: ({ timeOfDay, weekDays }: Filters) => void;
	filters: Filters;
	setThreeDaySwitch: (bool: boolean) => void;
	threeDaySwitch: boolean;
	setTimeOfDay: (timeOfDay: string) => void;
	setWeekDays: (weekDays: string[]) => void;
	weekDays: string[];
	timeOfDay: string;
}>) {
	const { t } = useTranslation('dateAndTime');
	return (
		<Dialog
			open={openFilterDialog}
			onClose={() => {
				setOpenFilterDialog(false);
				setTimeOfDay(filters.timeOfDay ?? '');
				setWeekDays(filters.weekDays ?? []);
			}}
			aria-labelledby="alert-dialog-title"
		>
			<DialogContent>
				<DayFilters
					threeDaySwitch={threeDaySwitch}
					timeOfDay={timeOfDay}
					setTimeOfDay={setTimeOfDay}
					weekDays={weekDays}
					setWeekDays={setWeekDays}
				/>
			</DialogContent>
			<DialogActions sx={{ backgroundColor: 'backgrounds.neutral' }}>
				<Button
					onClick={() => {
						setOpenFilterDialog(false);
						setTimeOfDay(filters.timeOfDay ?? '');
						setWeekDays(filters.weekDays ?? []);
					}}
					sx={{ textTransform: 'none' }}
				>
					<Typography color="primary.main" variant="buttonLabel">
						{t('cancel')}
					</Typography>
				</Button>
				<Button
					onClick={() => {
						setFilters({ weekDays, timeOfDay });
						setOpenFilterDialog(false);
						setThreeDaySwitch(false);
					}}
					sx={{ textTransform: 'none' }}
					data-test-id="button_apply_filter"
				>
					<Typography color="secondary.main" variant="buttonLabel">
						{t('apply')}
					</Typography>
				</Button>
			</DialogActions>
		</Dialog>
	);
}
